import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StatisticEditorBase } from '../statistic-editor-base';

@Component({
	selector: 'pp-editor-timepicker',
	templateUrl: './editor-timepicker.component.html',
	styleUrls: ['./editor-timepicker.component.scss']
})
export class EditorTimePickerComponent extends StatisticEditorBase implements OnInit {
	form: FormGroup;
	times: SelectItem[] = [];

	constructor(
		private fb: FormBuilder,
	) {
		super();
	}

	ngOnInit() {
		this.buildForm();
		this.buildTimes();

		this.form.patchValue({
			text: this.statistic.text
		});

		this.form.controls.text.valueChanges.subscribe(val => {
			if (val === undefined) return;
			this.statistic.text = val;
			this.emitChange();
		});
	}
	
	private buildTimes() {
		if (this.times.length > 0) return;

		const durationStep = 1; // minutes
		var startTime = new Date(1990, 0, 1, 0 ,0);
		this.times = [];
		let index = 0;
		for (let i = 0; i< (24*60); i += durationStep){
			this.times[index++] = { label: moment(startTime).format('hh:mm a') };
			  startTime = new Date(startTime.getTime() + durationStep * 60000);
		}
	}

	private buildForm() {
		this.form = this.fb.group({
			text: this.statistic.text || null
		});

		if (this.type.isRequired) {
			this.form.controls.text.setValidators(Validators.required);
		}
	}
}

class SelectItem {
	label: string;
}
